// extracted by mini-css-extract-plugin
export var container = "_un-0";
export var table = "_un-2";
export var tableWrapper = "_un-1";